import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {ArrowIcon} from '~library/svg/ArrowIcon';

type SkipButtonProps = {
  text: string;
  onClick: () => void;
  rightArrow?: boolean;
  textColor?: string;
};

export const SkipButton = ({
  onClick,
  text,
  rightArrow,
  textColor = 'charcoal',
}: SkipButtonProps) => (
  <Button
    variant="unstyled-button"
    onClick={onClick}
    data-qa-id="skip-button"
    className="rsvp-header__skip-button"
  >
    <Typography variant="label2" color={textColor}>
      {text}
    </Typography>
    {rightArrow && <ArrowIcon direction="right" ratio={0.75} />}
  </Button>
);
